import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class BedTypeService {
    static getbedType() {
        return axios
            .get(API_PATHS.getbedType)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }
    
    static postbedType(item) {
        return axios
            .post(API_PATHS.postbedType,
                item
            )
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default BedTypeService;